import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import logo from '../pages/auth/psgtech.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/Navbar.css';
import API_BASE_URL from "../api"; 

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('isLoggedIn'));
  const [role, setRole] = useState(localStorage.getItem('role') || 'student');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinksRef = useRef(null);

  const checkAuthState = () => {
    const loggedIn = localStorage.getItem('isLoggedIn');
    const userRole = localStorage.getItem('role') || 'student';
    setIsLoggedIn(loggedIn === 'true');
    setRole(userRole);
  };

  useEffect(() => {
    checkAuthState();
    const interval = setInterval(checkAuthState, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    checkAuthState();
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && navLinksRef.current && !navLinksRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleLogout = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });

      if (response.data.success) {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('role');
        localStorage.removeItem('userId');

        toast.success('Logged out successfully!', {
          position: 'top-right',
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            background: '#28a745',
            color: '#fff',
            borderRadius: '8px',
          },
        });

        setTimeout(() => {
          setIsLoggedIn(false);
          setRole('student');
          navigate('/login', { replace: true });
        }, 1500);
      } else {
        throw new Error('Logout failed on server');
      }
    } catch (err) {
      console.error('Logout error:', err);

      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('role');
      localStorage.removeItem('userId');

      toast.error('Logout failed, but session cleared. Redirecting...', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          background: '#dc3545',
          color: '#fff',
          borderRadius: '8px',
        },
      });

      setTimeout(() => {
        setIsLoggedIn(false);
        setRole('student');
        navigate('/login', { replace: true });
      }, 2000);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Determine the dashboard link based on role (only for admin/faculty)
  const getDashboardLink = () => {
    if (role === 'admin') {
      return { path: '/admin/dashboard', label: 'Admin Dashboard' };
    } else if (role === 'faculty') {
      return { path: '/faculty/dashboard', label: 'Faculty Dashboard' };
    }
    return null; // No dashboard link for students or other roles
  };

  const dashboardLink = getDashboardLink();

  return (
    <nav className="navbar">
      <button className="menu-button" onClick={toggleMenu}>
        <i className="fas fa-bars"></i>
      </button>
      <div className="logo">
        <img src={logo} alt="Logo" width="250" height="50" />
      </div>
      <ul className={`nav-links ${isMenuOpen ? 'show' : ''}`} ref={navLinksRef}>
        <li><Link to="/">Home</Link></li>
        {dashboardLink && (
          <li>
            <Link to={dashboardLink.path}>{dashboardLink.label}</Link>
          </li>
        )}
        {isLoggedIn ? (
          <li>
            <button className="logout-button" onClick={handleLogout}>
              Logout
            </button>
          </li>
        ) : (
          <>
            <li><Link to="/login">Login</Link></li>
            <li><Link to="/forgot-password">Forgot Password</Link></li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;